import React, {useState, useRef, useEffect} from 'react'
import { CgProfile } from 'react-icons/cg';
import { MdOutlinePhonelinkErase, MdOutlineFeedback } from "react-icons/md";
import { FiRefreshCw } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { IoMdLogOut } from "react-icons/io";
import Swal from 'sweetalert2';
import { successAlert } from '../utils/utils';
import localforage from "localforage";
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import {isGodMode} from '../utils/permissions';
import { useStateContext } from '../context/StateContext';
import { useLogout } from '../whitaijiFrontendLibrary/auth/hooks/useLogout';
import { dT } from './Translation';

localforage.config({
    name: 'reMind',
    isPersistent: true
})

const ProfileMenu = ({resetContextFn=() => {}}) => {
    const { user, dispatch } = useAuthContext(AuthContext)
        const logOutFn = () => {
      logout()
      setOpen(!open)
    }
    const { logout } = useLogout(AuthContext, resetContextFn) 
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const { hideTestButtons, language } = useStateContext() 

    const reset = async () => {
      process.env.NODE_ENV === "development" && console.log("resetting user", user)
      try {
        // Clear localforage
        await localforage.clear()

        // Re-dispatch LOGIN first to ensure auth state is maintained
        dispatch({ type: 'LOGIN', payload: user });
        
        successAlert("reMind resettato")
        navigate('/')
      } catch (error) {
        process.env.NODE_ENV === "development" && console.error("Reset error:", error)
        successAlert("Errore durante il reset")
      }
    }

    let menuRef = useRef();

    useEffect(() => {
        let handler = (e)=>{
          if(!menuRef.current.contains(e.target)){
            setOpen(false);
          }      
        };
    
        document.addEventListener("mousedown", handler);
        
        return() =>{
          document.removeEventListener("mousedown", handler);
        }
    
      });

      const onMenuClick = () => {
        setOpen(!open)
      }
  return (
    <div style={{zIndex:2000, position: 'relative'}} ref={menuRef}>
      <div style={{ height: '30px'}}>
        <UserIcon
          style={{marginTop:"8px"}}
          onClick={onMenuClick}
        />
      </div>
      <div className={`dropdown-menu-profile ${open? 'active' : 'inactive'}`} style={{position: 'absolute', top: '100%', right: 0}}>
        <ul>
          <DropdownItem 
            fn = {()=>{setOpen(!open)}} 
            reload = {false}
            icon = {<CgProfile size={20}/>} 
            text = {dT({en: 'Profile', it: 'Profilo'}, language)}//{"Profilo"}
            link = {"/profile"}
          /> 
          <DropdownItem 
            fn = {()=>{}} 
            reload = {true}
            icon = {<FiRefreshCw/>} 
            text = {dT({en: 'Reload', it: 'Ricarica'}, language)}//{"Ricarica"}
          /> 
          <DropdownItem 
            alert 
            alertMessage = {dT({en: 'Are you sure you want to reset reMind?', it: 'Sei sicuro di voler resettare reMind?'}, language)}//{"RESETTING"} 
            fn = {reset} 
            icon = {<MdOutlinePhonelinkErase/>} 
            alertTitle = {dT({en: 'ATTENTION!!', it: 'ATTENZIONE!!'}, language)}//{"ATTENZIONE!!"}
            link = {"/"}
            text = {"!Reset"}
          />
          <DropdownItem 
            fn = {logOutFn} 
            icon = {<IoMdLogOut/>} 
            link = {"/home"}
            text = {"Logout"}
          />
          <DropdownItem 
            fn = {()=>{setOpen(!open)}}  
            icon = {<MdOutlineFeedback/>} 
            link = {"/feedback"}
            text = {"Feedback"}
          />
          <li className="dropdownItem-profile">v 1.0.1</li>
        </ul>
      </div>
    </div>
  )
}

function DropdownItem(props){
  const navigate = useNavigate();
  
  const onMenuClick = () => {
    const alert = () => {
      Swal.fire({
          title:  props?.alertTitle,
          text: props?.alertMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: "SI', PROSEGUI",
          cancelButtonText: "ANNULLA"
        }).then((result) => {
          if (result.isConfirmed) {
            props?.fn && props?.fn?.()
            if(props?.link){
              navigate(props?.link);
              window.location.reload();
            }
            else if(props?.reload){
              window.location.reload();
            }
          }
        })
    }
    if(props?.alert){
      alert()
    } else {
      props?.fn && props?.fn?.()
      if(props?.link){
        navigate(props?.link);
        if(props?.reload){
          window.location.reload();
        }
      }
      else if(props?.reload){
        window.location.reload();
      }
    }
  }
 
  return(
    <li onClick={onMenuClick}  className = 'dropdownItem-profile'>
      {props.img && <img src={props.img} alt=""></img>}
      <div style={{marginRight:"8px", marginTop:"6px"}}>
        {props.icon && props.icon}
      </div>
      {props.text}
    </li>
  );
}

export const UserIcon = ({otherUser, onClick, date="", dateText="", userPicture, style, size=30, name, nameInitials, dateInline}) => {
  const {user} = useAuthContext(AuthContext)

  const showTime = () => {
    if(isGodMode(user)) return true
    return false
  }
  
  const iconSize  = {width:`${size}px`, height:`${size}px`}
  //const iconSize  = {width:`${size}px`}
  const enabledStyle = {cursor: "pointer",...style}
  const disabledStyle = {...style }
  
  const USER = otherUser ? otherUser : user 
  
  const userRoundPicture = () => {
    if(userPicture){
      return userPicture
    }
    if(USER?.profilePictureUrl){
      return USER.profilePictureUrl
    }
    return undefined    
  }

  return (
    <>
      <div className='menu-container-profile' onClick={onClick} style={onClick ? enabledStyle : disabledStyle}>
        {userRoundPicture() ? 
          <div style={{...iconSize}}> 
            <img  className='profile-icon' src={userRoundPicture()} alt=""></img>
          </div>
          
           :
          <CgProfile style={{...iconSize}} className='profile-icon' />
        } 
        <div>
          <VisDiv rules={[date]} style={{marginLeft:"3px", fontSize:"12px", fontWeight:"bold"}}><p>{dateText}</p></VisDiv>
          <VisDiv style={{marginLeft:"3px", fontSize:"12px", fontSize:"16px"}} rules={[name,USER]}>{USER?.firstName + " " + USER?.lastName}</VisDiv>
          <VisDiv style={{marginLeft:"3px", fontSize:"12px"}} rules={[nameInitials,USER]}>{USER?.firstName + " " + USER?.lastName}</VisDiv> 
        </div>
      </div>
    </>
  )
}

export default ProfileMenu
